import { PriorClaim } from "@covertree/new-business-graphql";
import { PriorClaimsFormInput } from "@covertree/new-business-forms/src/validatorsAndTypes/claimsListForm";
import {
  mapFormattedClaimCategoryToPriorClaimCategory,
  mapPriorClaimCategoryToFormattedClaimCategory,
} from "@covertree/new-business-forms/src/mappings/priorClaimsCategoryMaps";

export const mapPriorClaimsToPriorClaimsFormInputs = (
  priorClaims?: PriorClaim[],
  policyholderName: `${string}|${string}` = "|"
): PriorClaimsFormInput[] =>
  priorClaims?.map(
    ({
      category,
      amount,
      date,
      source,
      fieldGroupLocator,
      catastrophe,
      subjects,
    }) => {
      const subjectFirstName = subjects[0].firstName;
      const subjectLastName = subjects[0].lastName;

      const insuredName =
        subjectFirstName || subjectLastName
          ? `${subjectFirstName}|${subjectLastName}`
          : policyholderName;

      return {
        category: mapPriorClaimCategoryToFormattedClaimCategory(category),
        amount,
        catastrophe,
        date,
        source,
        insured: insuredName.toUpperCase(),
        fieldGroupLocator,
      };
    }
  ) || [];

export const mapPriorClaimsFormInputsToPriorClaims = (
  claims: PriorClaimsFormInput[]
): PriorClaim[] =>
  claims.map(
    ({
      amount,
      date,
      catastrophe,
      category,
      source,
      insured,
      fieldGroupLocator,
    }) => ({
      amount,
      category: mapFormattedClaimCategoryToPriorClaimCategory(category),
      catastrophe: catastrophe ?? false,
      date,
      fieldGroupLocator: fieldGroupLocator ?? "",
      source,
      subjects: [
        {
          firstName: insured?.split("|")[0],
          lastName: insured?.split("|")[1],
        },
      ],
    })
  );
